import { render, staticRenderFns } from "./HeroSlider.vue?vue&type=template&id=8292131a&scoped=true&"
import script from "./HeroSlider.vue?vue&type=script&lang=js&"
export * from "./HeroSlider.vue?vue&type=script&lang=js&"
import style0 from "./HeroSlider.vue?vue&type=style&index=0&id=8292131a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8292131a",
  null
  
)

export default component.exports